module.exports = __webpack_public_path__ + "img/career-category-back.efbc0750.svg";